import { usePanorama as usePanoramaGeneric } from '@wix/package-picker-shared';
export const useStudioPanorama = () => {
  return usePanoramaGeneric();
};
//# sourceMappingURL=useStudioPanorama.js.map